import Login from "./Login";
import Register from "./Register";
import Check from "./Check";

export default {
  Login,
  Register,
  Check,
};
